// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1hXco","col":"styles_col__1a0tZ","fulfillmentStatus":"styles_fulfillmentStatus__1wF-i","emailCol":"styles_emailCol__2Nvx1"};